import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import "../../css/PortChange.css";
import { fetchAsyncPortInfo, PortInfoStatus } from "../portInfo/PortInfoSlice";
import { fetchAsyncPortChange, changeMobility } from "./PortChangeSlice";

const PortChange: React.FC = () => {
  const portInfoData = useSelector(PortInfoStatus);
  const dispatch = useDispatch();
  const location = useLocation();
  const item: any = location.state;
  const [selectedPort, setSelectedPort] = useState("");
  const navigate = useHistory();

  //データ取得
  useEffect(() => {
    //状態が初期値だったらAPIリクエスト
    if (portInfoData === null) {
      dispatch(fetchAsyncPortInfo());
    }
  }, [dispatch]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // 選択されたポートIDをAPIリクエストに使用
    dispatch(
      fetchAsyncPortChange({
        change_mobility: item.state.item.body_number,
        change_port: selectedPort,
      })
    ).then(() => {
      navigate.push("/Segway_info", {
        fromPortChange: true,
        bodyNumber: item.state.item.body_number,
        fromPort: item.state.item.port_id,
        toPort: selectedPort,
      });
    });
  };

  return (
    <div className="position_row">
      <div className="port_change_container">
        <h1 className="port_change_title">ポート場所変更</h1>
        <div className="port_change">
          <form
            onSubmit={handleSubmit}
            method="post"
            className="port_change_form">
            <div className="change_item">
              機体情報 : 車体ナンバー:{item.state.item.body_number} QRコード:
              {item.state.item.qrcode} 現在のポート:{item.state.item.port_name}
            </div>
            <select
              name="change_port"
              className="change_input"
              value={selectedPort}
              onChange={(e) => setSelectedPort(e.target.value)}
              required>
              <option value="" disabled>
                変更先ポートを選択してください
              </option>
              {portInfoData !== null &&
                portInfoData.map((item, index) => (
                  <option key={index} value={item.port_id}>
                    {item.port_id} {item.port_name}
                  </option>
                ))}
            </select>
            <input
              type="hidden"
              value={item.state.item.body_number}
              name="change_segway"
            />
            <input type="submit" value="確定" className="change_button" />
          </form>
        </div>
      </div>
    </div>
  );
};
export default PortChange;
